import React from "react";
import "./styles.css";
import MovieContextProvider from "./contexts/MovieContext";
import Navbar from "./components/Navbar";
import MovieList from "./components/MovieList";
import NewMovieForm from "./components/NewMovieForm";
import ProjectInfo from "./components/ProjectInfo";

export default function App() {
  return (
    <div className="App">
      <MovieContextProvider>
        <Navbar />
        <MovieList />
        <NewMovieForm />
      </MovieContextProvider>
      <ProjectInfo />
    </div>
  );
}
